import { Light } from './color.js';

export const FrameBackgroundColor = Light;
